export default function translate($translateProvider) {
    $translateProvider.translations('es', {
      'NEW_UPDATE_AVAILABLE_MESSAGE': 'Hay disponible una nueva versión',
      'NEW_UPDATE_AVAILABLE_ACTION': 'ACTUALIZAR',
      // ng-admin translations
      'BACK': 'Volver',
      'DELETE': 'Borrar',
      'CREATE': 'Crear',
      'ADD': 'Añadir',
      'ADD_EVENT': 'Añadir evento',
      'EDIT': 'Editar',
      'EXPORT': 'Exportar',
      'ADD_FILTER': 'Añadir filtro',
      'SEE_RELATED': 'Ver {{ entityName | translate }}',
      /**
       * FIXME: it seems that ng-admin doesn't suppport spanish tranlations for
       *    LIST since { 'LIST': 'Listado de {{ entityName }}' } returns
       *    'Actividades Listado de'. For this reasson we are overriding the
       *    title on the entities list as for instance:
       *
       *        activity.listView().title('{{ "Activities" | translate }}')
       */
      'LIST': 'Listado',
      'SHOW': 'Mostrar',
      'SAVE': 'Guardar',
      'N_SELECTED': '{{ length }} Seleccionados',
      'ARE_YOU_SURE': 'Está seguro?',
      'YES': 'Si',
      'NO': 'No',
      'FILTER_VALUES': 'Filtrar valores',
      'CLOSE': 'Cerrar',
      'CLEAR': 'Limpiar',
      'CURRENT': 'Actual',
      'REMOVE': 'Borrar',
      'ADD_NEW': 'Añadir nuevo {{ name }}',
      'BROWSE': 'Navegar',
      'N_COMPLETE': '{{ progress }}% Completado',
      'CREATE_NEW': 'Crear',
      'SUBMIT': 'Aceptar',
      'SAVE_CHANGES': 'Guardar cambios',
      'BATCH_DELETE_SUCCESS': 'Elementos borrados con éxito',
      'DELETE_SUCCESS': 'Elemento borrado con éxito',
      'ERROR_MESSAGE': 'Ha ocurrido un error (código: {{ status }})',
      'INVALID_FORM': 'Formulario inválidado',
      'CREATION_SUCCESS': 'Elemento creado con éxito',
      'EDITION_SUCCESS': 'Cambios guardados con éxito',
      'ACTIONS': 'Acciones',
      'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> de <strong>{{ total }}</strong>',
      'NO_PAGINATION': 'Entrada no encontrada',
      'PREVIOUS': '« Anterior',
      'NEXT': 'Siguiente »',
      'DETAIL': 'Detalles',
      'STATE_CHANGE_ERROR': 'Cambio de estado de error: {{ message }}',
      'STATE_FORBIDDEN_ERROR': 'Un error 403 ha ocurrido en el servidor: {{ message }}',
      'NOT_FOUND': 'No encontrado',
      'NOT_FOUND_DETAILS': 'La página que estás buscando no ha sido encontrada. Espera unos minutos antes de intentarlo de nuevo.',


      'Current Password': 'Contraseña actual',
      'New Password': 'Nueva contraseña',
      'Repeat Password': 'Confirme contraseña',

      // Custom translations
      'Configuration': 'Configuración',
      'Edition': 'Edición',
      'Month': 'Mes',
      'Week': 'Semana',
      'Generate': 'Generar',
      'Print': 'Imprimir',
      'Planning': 'Planificación',
      'Help': 'Ayuda',

      'Activities': 'Actividades',
      'Activity': 'Actividad',
      'activity': 'actividad',

      'Properties': 'Propiedades',
      'Property': 'Propiedad',
      'property': 'propiedad',
      'properties': 'propiedades',

      'Values': 'Valores',
      'values': 'valores',
      'Value': 'Valor',

      'Groups': 'Grupos',
      'Group': 'Grupo',
      'group': 'grupo',

      'Exercises': 'Ejercicios',
      'exercises': 'ejercicios',
      'Exercise': 'Ejercicio',
      'exercise': 'Ejercicio',

      'Category': 'Categoría',
      'Categories': 'Categorías',
      'category': 'categoría',

      'Cognitive Functions': 'Funciones Cognitivas',
      'Cognitive Function': 'Función Cognitiva',
      'cognitive function': 'función cognitiva',

      'Group Therapies': 'Terapias de grupo',
      'Group Therapy': 'Terapia de grupo',
      'Centers': 'Centros',
      'Calendar': 'Calendario',

      // TODO: imporove translation
      'Periodic Events': 'Horarios',
      'periodic event': 'horario',
      'Events': 'Horarios',
      'events': 'horarios',
      'event': 'evento',

      'Evaluations': 'Evaluaciones',
      'evaluations': 'evaluaciones',
      'Evaluations Grouped': 'Evaluaciones (agrupadas)',
      'Count': 'Recuento',

      'Title': 'Título',
      'Objective': 'Objetivo',
      'Description': 'Descripción',
      'Name': 'Nombre',
      'Parent category': 'Categoría padre',
      'Start Time (hh:mm)': 'Hora de inicio (hh:mm)',
      'End Time (hh:mm)': 'Hora de fin (hh:mm)',
      'Exercises Count': 'Número de ejercicios',
      'M': 'L',
      'T': 'M',
      'W': 'X',
      'R': 'J',
      'F': 'V',
      'S': 'S',
      'U': 'D',
      'Monday': 'Lunes',
      'Tuesday': 'Martes',
      'Wednesday': 'Miércoles',
      'Thursday': 'Jueves',
      'Friday': 'Viernes',
      'Saturday': 'Sábado',
      'Sunday': 'Domingo',
      'Date': 'Fecha',
      'Position': 'Posición',

      // Evaluations
      'Quantity': 'Cantidad',
      'Time range': 'Rango de tiempo',
      'LAST_N_MONTHS': 'Últimos {{ amount }} meses',

      // Error messages
      'ERROR_SAVING_EVALUATIONS': 'Error {{ status }}: No ha sido posible guardar la evaluación.',

      // Dashboard
      'Days Scheduled': 'Días Planificados',
      'Exercises Evaluated': 'Ejercicios Evaluados',
      'Recent Evaluations': 'Evaluaciones Recientes',
      'Evaluations Summary (past 2 months)': 'Resumen de Evaluaciones (últimos 2 meses)',

      // Stats
      'Statistics': 'Estadísticas',
      'Performed exercises': 'Ejercicios realizados',
      'From': 'Desde',
      'To': 'Hasta',
      'Exercises by CF': 'Ejercicios por F.C.',
      'Performed exercises by CF': 'Distribución de ejercicios realizados por función cognitiva',
      'STAT_TITLE_EXERCISES_PER_CF': 'Número de ejercicios por función cognitiva'
    });
    // FIXME: don't inforce default language
    $translateProvider.preferredLanguage('es');
    $translateProvider.useSanitizeValueStrategy(null);
}

translate.$inject = ['$translateProvider'];



// WEBPACK FOOTER //
// ./js/i18n/es.js